import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ChefsPage = lazy(() => import('../pages/chefs/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ListBusinessPage = lazy(() => import('../pages/list-business/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

import ProfilePage from '../pages/profile/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/chefs',
    element: <ChefsPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/list-business',
    element: <ListBusinessPage />
  },
  {
    path: '/profile/private-chef-johannesburg-gordon',
    element: <ProfilePage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
